import React, { useState, useEffect } from "react";

export default function DevMenu({
  onSetDrag,
  onToggleCoords,
  showCoords,
  onClose,
  onOpenImportLootspot,
  onToggleShowIds,
  showIds,
}) {
  const [drag, setDrag] = useState(false);
  // Load position from localStorage or default to {x:40, y:40}
  const [pos, setPos] = useState(() => {
    const saved = localStorage.getItem("devmenu_pos");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch {}
    }
    return { x: 40, y: 40 };
  });
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setDrag(true);
    setOffset({ x: e.clientX - pos.x, y: e.clientY - pos.y });
  };
  useEffect(() => {
    if (!drag) return;
    const move = (e) => {
      setPos({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    };
    const up = () => setDrag(false);
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
    };
  }, [drag, offset]);

  // Save position every time it changes
  useEffect(() => {
    localStorage.setItem("devmenu_pos", JSON.stringify(pos));
  }, [pos]);

  return (
    <div
      className="fixed rounded bg-white p-4 shadow"
      style={{
        left: pos.x,
        top: pos.y,
        minWidth: 220,
        cursor: drag ? "grabbing" : "grab",
        userSelect: "none",
        zIndex: 10000,
      }}
    >
      <div
        className="mb-2 flex items-center justify-between"
        onMouseDown={handleMouseDown}
        style={{ cursor: "grab" }}
      >
        <h2 className="text-lg font-bold">Developer menu</h2>
        <button
          onClick={onClose}
          className="ml-2 text-xl font-bold text-gray-500 hover:text-red-600"
        >
          &times;
        </button>
      </div>
      <button
        className="mb-2 block w-full rounded bg-yellow-500 px-4 py-2 text-white"
        onClick={() => onSetDrag()}
      >
        Add Marker
      </button>
      <button
        className="mb-2 block w-full rounded bg-orange-700 px-4 py-2 text-white"
        onClick={onOpenImportLootspot}
      >
        Import Lootspot
      </button>
      <button
        className="block w-full rounded bg-gray-700 px-4 py-2 text-white"
        onClick={onToggleCoords}
      >
        {showCoords ? "Hide coordinates" : "Show coordinates"}
      </button>
      <button
        className="mt-2 block w-full rounded bg-gray-700 px-4 py-2 text-white"
        onClick={onToggleShowIds}
      >
        {showIds ? "Hide marker IDs" : "Show marker IDs"}
      </button>
    </div>
  );
}
